import * as React from "react";
import { ControlLabel, Form, FormControl, FormGroup } from "react-bootstrap";
import Message from "../../MapStore2/web/client/plugins/locale/Message";
import { FormEvent } from "react";

export interface ScaleBoxStateProps {
    scales?: any[];
    currentZoomLvl?: number;
    minZoom: number;
}

export interface ScaleBoxDispatchProps {
    onChange: (zoomLvl: any, mapStateSource: any) => void;
}

const ScaleBox = (props: ScaleBoxStateProps & ScaleBoxDispatchProps) => {
    const onComboChange = (event: FormEvent<FormControl>) => {
        let selectedZoomLvl = parseInt((event.nativeEvent.target as HTMLSelectElement).value, 10);
        props.onChange(selectedZoomLvl, props.scales![selectedZoomLvl]);
    };

    const template = (scale: number) => (scale < 1 ? Math.round(1 / scale) + " : 1" : "1 : " + Math.round(scale));

    const getOptions = () => {
        return props.scales
            ? props.scales
                  .map((item, index: number) => {
                      return (
                          <option value={index} key={index}>
                              {template!(item)}
                          </option>
                      );
                  })
                  .filter((element, index) => index >= props.minZoom)
            : null;
    };

    return (
        <div id={"mapstore-scalebox"}>
            <Form inline>
                <FormGroup bsSize={"small"}>
                    <ControlLabel>
                        <Message msgId={"mapScale"} />
                    </ControlLabel>
                    <FormControl componentClass={"select"} onChange={onComboChange} value={props.currentZoomLvl || ""}>
                        {getOptions()}
                    </FormControl>
                </FormGroup>
            </Form>
        </div>
    );
};

ScaleBox.defaultProps = {
    currentZoomLvl: 0,
    minZoom: 0,
    onChange: () => {},
};
export default ScaleBox;
